import WebServiceRequest from './WebServiceRequest'


class GetAllRates extends WebServiceRequest {
    constructor (context) {
        super(context)
        super.setMethod('GET')
        super.setTag('Boosters/GetAllBoosterRates')
    }
    setParams(data){
        super.setRequestParam(data)
    }
}

export {
    GetAllRates,
}
